import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import { Button } from '@apollo/orbit';
import { Popover } from '@apollo/space-kit/Popover';
import React from 'react';

import { PlainHtmlButton } from 'src/components/common/plainHtmlButton/PlainHtmlButton';
import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';

interface Props {
  className?: string;
  graphId: string;
  onMarkSafeClick: () => void;
  onIgnoreClick: () => void;
  exactlyOneChange: boolean;
}

export function DefaultOverrideButton({
  className,
  graphId,
  onMarkSafeClick,
  onIgnoreClick,
  exactlyOneChange,
}: Props) {
  return (
    <PermissionWarning
      graphId={graphId}
      graphPermissions="canWriteCheckConfiguration"
      childRenderer={(hasPermission) => (
        <Popover
          placement="bottom-start"
          content={
            <>
              <PlainHtmlButton
                className="rounded p-2 text-left hover:bg-silver-light active:bg-silver"
                onClick={onMarkSafeClick}
              >
                <h3 className="text-sm">
                  Mark change{exactlyOneChange ? '' : 's'} as safe
                </h3>
                <p className="text-xs text-secondary">
                  Do not fail future checks when
                  {exactlyOneChange
                    ? ' this change is '
                    : ' these changes are '}
                  observed for this operation.
                </p>
              </PlainHtmlButton>
              <PlainHtmlButton
                className="rounded p-2 text-left hover:bg-silver-light active:bg-silver"
                onClick={onIgnoreClick}
              >
                <h3 className="text-sm">Ignore operation</h3>
                <p className="text-xs text-secondary">
                  Do not fail future checks when any breaking changes to this
                  operation are observed.
                </p>
              </PlainHtmlButton>
            </>
          }
          disabled={!hasPermission}
          trigger={
            <Button
              className={className}
              variant="secondary"
              rightIcon={<IconChevronDown />}
              isDisabled={!hasPermission}
            >
              Override
            </Button>
          }
        />
      )}
    />
  );
}
